// this file holds polyfills, mostly for css or scroll stuff for safari

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
